import { IsVisibleOnTooltipBaseValueConverter } from 'General/Resources/ValueConverters/IsVisibleOnTooltipBase';
export class IsVisibleOnTooltipValueConverter extends IsVisibleOnTooltipBaseValueConverter {

}